import { MutationOptions, useMutation } from "react-query";
import { APIError, APIResponse, API_URL_V3, post } from "../api";

export interface BillCablePurchasePayload {
  pin: string;
  service_type: string;
  smartcard_number: string;
  phone: string;
  amount: number;
  plan_code: string;
  plan_name: string;
  payment_option_code: string;
  agentReference: string;
}

/**
 * Cable TV purchase via the provider-agnostic bills layer (/v3/bills).
 */
function useBillCablePurchase(
  options?: MutationOptions<APIResponse<any>, APIError, BillCablePurchasePayload>
) {
  const {
    mutate: purchaseCable,
    isLoading: purchasingCable,
    isError: isPurchaseError,
    error: purchaseError,
    data: purchaseResponse,
  } = useMutation<APIResponse<any>, APIError, BillCablePurchasePayload>(
    (payload) =>
      post(API_URL_V3 + "/bills/cable-tv/purchase", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }),
    options
  );

  return {
    purchaseCable,
    purchasingCable,
    isPurchaseError,
    purchaseError,
    purchaseResponse,
  };
}

export default useBillCablePurchase;
